import React, {useEffect} from 'react';
import { useT } from '../../helpers/i18n';

import Checkers from '../../helpers/class/Checkers';
import {useSelector} from "react-redux";
import {fetchBuilderSettingByKey} from "../../helpers/MethodHelper";
import SocialLinks from '../SocialLinks';
import RawEmbedHtml from '../RawEmbedHtml';

const stripEmbeddedSocialIcons = (html) => {
  if (!Checkers.isValidString(html)) return html
  return html.replace(/<ul[^>]*>[\s\S]*?data-prefix="fab"[\s\S]*?<\/ul>/gi, '')
}

export default function ContactLocations ( props ) {
  const t = useT();

  const contactOver = props.hasOwnProperty('contactOver') ? props.contactOver : null

  const isCoordinate = ( value ) => value != null && String( value ).trim() !== '' && Number.isFinite( Number( value ) ) && Number( value ) !== 0

  let url = null;
  if (isCoordinate(props.latitude) && isCoordinate(props.longitude)) {
    url = 'https://www.google.com/maps/search/?api=1&amp;query=' + props.latitude + ',' + props.longitude;
  } else {
    url = null;
  }
  let locations_class = 'col-12 col-sm-12 col-md-6 pe-md-5';
  if (!props.showContactForm) {
    locations_class = 'col-md-4 offset-md-4 col-sm-12 offset-sm-0';
  }

  const showBranchesLocations = useSelector(
      state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_contact_show_branches') == '1' ? true : false
  );

  const contactEmail = useSelector(
      state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_contact_page_email')
  );

  const contactEmailOverride = Checkers.isValidString(props.contactEmailOverride)
      ? props.contactEmailOverride
      : Checkers.isValidString(contactEmail)
          ? contactEmail
          : props.contactEmails

  const contactPhoneBlock = props.hasOwnProperty('contactPhone') ? props.contactPhone : null

  const hasContactPhoneBlock = contactPhoneBlock != null && contactPhoneBlock.hasOwnProperty('app_section_content') && Checkers.isValidString(contactPhoneBlock.app_section_content)

  const contactEmailBlock = props.hasOwnProperty('contactEmail') ? props.contactEmail : null

  const hasContactEmailBlock = contactEmailBlock != null && contactEmailBlock.hasOwnProperty('app_section_content') && Checkers.isValidString(contactEmailBlock.app_section_content)

  // useEffect( () => {
  //   console.log("forDebug", "contactEmailOverride", contactEmailOverride)
  //   console.log("forDebug", "showBranchesLocations", showBranchesLocations)
  //   console.log("forDebug", "props.locations", props.locations)
  // })

  const renderLocation = (location, key) => (
      <div key={key} className={props.isManager ? "pe-3" : "pe-3 w-100"}>
        {location.location_title != null &&
            <p className="text-uppercase letter-sp-normal fw-normal hint-text m-b-0">
              {
                Checkers.isValidString(props.contactTitleOverride) ?
                    props.contactTitleOverride
                    :
                    location.location_title
              }
            </p>
        }

        <address className={props.isManager ? "my-2 mb-3" : "my-2"}>
          {Checkers.isValidString(location.address) ? location.address : ''}
          <br/>
          {Checkers.isValidString(location.city) ? location.city : ''}
          {Checkers.isValidString(location.zip) ? ', ' + location.zip : ''}
          <br/>
          {Checkers.isValidString(location.country) ? location.country : ''}
        </address>
        {
          props.isManager ?
              // PM: unchanged, exactly as before - always the page-level url.
              (
                url != null ?
                    <p className="text-uppercase letter-sp-normal fw-bold small-text hint-text no-margin p-r-10">
                      <a target="_blank" className="view-map" href={url} rel="noreferrer">
                        {t('contact.viewOnMap')}
                      </a>
                    </p>
                    : ''
              )
              :
              // Non-PM: prefer the property's own coordinates (from content.details) over
              // the page/legal-entity location's - matches the old Twig's lat/lon vars.
              ( () => {
                const lat = isCoordinate( props.propertyLat ) ? props.propertyLat : location.latitude;
                const lng = isCoordinate( props.propertyLng ) ? props.propertyLng : location.longitude;
                const mapUrl = isCoordinate( lat ) && isCoordinate( lng )
                    ? 'https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lng
                    : url;
                return Checkers.isValidString( mapUrl ) ?
                    <p className="text-uppercase letter-sp-normal fw-bold small-text hint-text no-margin p-r-10">
                      <a target="_blank" className="view-map text-design-color text-decoration-none fw-bold" href={mapUrl} rel="noreferrer">
                        {t('contact.viewOnMap')}
                      </a>
                    </p>
                    : '';
              } )()
        }
       
        {
          (props.isManager || props.managerContact == null || props.managerContact.showOwnerContactInfo) &&
          <>
            {
              location.hasOwnProperty('items') ?
                  location.items.length > 0 ?
                      location.items.map((item, key) => (
                          item.slug.includes('phone') ?
                              item.value != null ?
                                  <React.Fragment key={'location-items-phone-' + key} >
                                    {
                                      Checkers.isValidString(props.contactPhoneOverride) && !hasContactPhoneBlock ?
                                          <React.Fragment key={'location-items-' + key} />
                                          :
                                          <>
                                            {
                                              hasContactPhoneBlock ?
                                                  // the contact_phone section is rendered once, after the items
                                                  <></>
                                                  :
                                                  <p key={key}
                                                     className="letter-sp-normal fw-bold no-margin p-r-10">
                                            <span
                                                className="text-uppercase letter-sp-normal fw-bold text-master no-margin fs-12 p-r-10">{t('contact.tel')}</span>
                                                    {
                                                      item.phone_prefix != null ?
                                                          <a href={'tel:+' + item.phone_prefix + item.value}
                                                             className="fs-14 fw-bold hint-text text-master text-design-color">(+{item.phone_prefix}) {item.value}</a>
                                                          :
                                                          <a href={'tel:' + item.value}
                                                             className="fs-14 fw-bold hint-text text-master text-design-color">{item.value}</a>
                                                    }
                                                  </p>
                                            }
                                          </>
                                    }
                                  </React.Fragment>
                                  : <React.Fragment key={'location-items-' + key}/>
                              :
                              <React.Fragment key={'location-items-email-' + key}>
                                {
                                  hasContactEmailBlock ?
                                      // the contact_email section is rendered once, after the items
                                      <></>
                                      :
                                      <>
                                        {
                                          Checkers.isValidString(contactEmailOverride) ?
                                              <React.Fragment key={'location-items-email-' + key}/>
                                              :
                                              <>
                                                {
                                                  item.slug.includes('email') ?
                                                      item.value != null ?
                                                          <p key={key}
                                                             className="letter-sp-normal fw-bold no-margin p-r-10">
                                                            <span className="text-uppercase letter-sp-normal fw-bold text-master no-margin fs-12 p-r-10">{t('contact.email')}</span>
                                                            <a href={'mailto:' + item.value} className="fs-14 fw-bold hint-text text-master text-design-color">{item.value}</a>
                                                          </p>
                                                          :
                                                          <></>
                                                      :
                                                      <></>
                                                }
                                              </>
                                        }
                                      </>
                                }
                              </React.Fragment>
                      ))
                      : ''
                  : ''
            }
            {
              hasContactPhoneBlock ?
                  <div dangerouslySetInnerHTML={{__html: stripEmbeddedSocialIcons(contactPhoneBlock.app_section_content)}}/>
                  : <></>
            }
            {
              hasContactEmailBlock ?
                  <div dangerouslySetInnerHTML={{__html: stripEmbeddedSocialIcons(contactEmailBlock.app_section_content)}}/>
                  : <></>
            }
            {
              Checkers.isValidString(props.contactPhoneOverride) && !hasContactPhoneBlock ?
                  <>
                    <p key={key} className="contactPhoneOverride letter-sp-normal fw-bold no-margin p-r-10">
                      <span className="text-uppercase letter-sp-normal fw-bold text-master no-margin fs-12 p-r-10">{t('contact.tel')}</span>
                      <a href={'tel:' + props.contactPhoneOverride}
                         className="fs-14 fw-bold hint-text text-master text-design-color">{props.contactPhoneOverride}</a>
                    </p>
                  </>
                  : <></>
            }

            {
              Checkers.isValidString(contactEmailOverride) && !hasContactEmailBlock ?
                  <>
                    <p key={key} className="letter-sp-normal fw-bold no-margin p-r-10">
          <span
              className="text-uppercase letter-sp-normal fw-bold text-master no-margin fs-12 p-r-10">{t('contact.email')}</span>
                      <a href={'mailto:' + contactEmailOverride}
                         className="fs-14 fw-bold hint-text text-master text-design-color">{contactEmailOverride}</a>
                    </p>
                  </>
                  :
                  <></>
            }
          </>
        }
      </div>
  );

  const locationsList = (
      props.locations != null ?
          <div className={props.isManager ? "d-flex flex-row flex-wrap w-100 m-0" : "col-12 col-sm-6 d-flex flex-row flex-wrap m-0 "}>
            {
              props.locations.map((location, key) => {
                if (key>0 && !showBranchesLocations) {
                  return
                }

                return renderLocation(location, key);
              })
            }
          </div>
          : ''
  );

  return (
      <div className={locations_class}>
        {
          contactOver!==null && contactOver.hasOwnProperty('app_section_content') && Checkers.isValidString(contactOver.app_section_content) ?
              <div dangerouslySetInnerHTML={{__html: contactOver.app_section_content}} />
              :
              <>
                <h2 className="m-b-20 hidden-xs">{props.contactFormTitle != null ? props.contactFormTitle : t('contact.howCanWeAssist')}</h2>
                {
                  props.isManager ?
                      locationsList
                      :
                      <div className="p-r-40 sm-p-r-0">
                        <br/>
                        <div className="row m-b-40">
                          {locationsList}
                          {
                            props.managerContact != null && props.managerContact.showInContact &&
                              <div className="col-12 col-sm-6 mt-4 mt-sm-0">
                                <p className="fs-12 m-b-10">
                                  {props.managerContact.showManagerContact ? t('contact.salesQueries') : t('contact.salesManagedBy')}
                                </p>
                                {
                                  Checkers.isValidString(props.managerContact.logo) ?
                                      <a href={Checkers.isValidString(props.managerContact.url) ? props.managerContact.url : undefined}
                                         target={Checkers.isValidString(props.managerContact.url) ? '_blank' : undefined}
                                         rel="noreferrer">
                                        {/* eslint-disable-next-line @next/next/no-img-element */}
                                        <img style={{ maxWidth: 120 }} src={props.managerContact.logo} alt="manager logo" className="logo_footer" />
                                      </a>
                                      :
                                      Checkers.isValidString(props.managerContact.title) &&
                                        <p className="block-title hint-text m-b-0">{props.managerContact.title}</p>
                                }
                                {
                                  Checkers.isValidString(props.managerContact.motto) &&
                                    <p className="fs-12 font-montserrat all-caps m-b-0">{props.managerContact.motto}</p>
                                }
                                {
                                  Checkers.isValidString(props.managerContact.tel) &&
                                    <p className="hint-text no-margin">
                                      <span className="fs-12 font-montserrat bold all-caps p-r-10">{t('contact.tel')}</span>
                                      <a href={'tel:' + props.managerContact.tel.replace(/[^\d+]/g, '')}
                                         className="fs-14 hint-text text-master text-design-color fw-bold">{props.managerContact.tel}</a>
                                    </p>
                                }
                                {
                                  // like the Lodge: mobile and fax of the manager after the phone
                                  Checkers.isValidString(props.managerContact.mobile) &&
                                    <p className="hint-text no-margin">
                                      <span className="fs-12 font-montserrat bold all-caps p-r-10">{t('contact.mob')}</span>
                                      <a href={'tel:' + props.managerContact.mobile.replace(/[^\d+]/g, '')}
                                         className="fs-14 hint-text text-master text-design-color fw-bold">{props.managerContact.mobile}</a>
                                    </p>
                                }
                                {
                                  Checkers.isValidString(props.managerContact.fax) &&
                                    <p className="hint-text no-margin">
                                      <span className="fs-12 font-montserrat bold all-caps p-r-10">{t('contact.fax')}</span>
                                      <span className="fs-14 hint-text text-master fw-bold">{props.managerContact.fax}</span>
                                    </p>
                                }
                                {
                                  Checkers.isValidString(props.managerContact.email) &&
                                    <p className="hint-text no-margin">
                                      <span className="fs-12 font-montserrat bold all-caps p-r-10">{t('contact.email')}</span>
                                      <a href={'mailto:' + props.managerContact.email}
                                         className="fs-14 hint-text text-master text-design-color fw-bold">{props.managerContact.email}</a>
                                    </p>
                                }
                              </div>
                          }
                        </div>
                        <SocialLinks isManager={props.isManager} socialLinks={props.socialLinks} />
                        <br/>
                      </div>
                }
              </>
        }
      </div>
  )
}
